import { lazy, type ComponentType } from "react";

function isRetryableImportError(error: unknown): boolean {
  if (!(error instanceof Error)) return false;
  return /Failed to fetch dynamically imported module|error loading dynamically imported module|Outdated Optimize Dep/i.test(
    error.message,
  );
}

export function lazyPage<M extends Record<N, ComponentType>, N extends string>(
  loader: () => Promise<M>,
  exportName: N,
) {
  return lazy(() =>
    loader()
      .catch(async (error: unknown) => {
        if (!isRetryableImportError(error)) throw error;
        await new Promise((resolve) => {
          setTimeout(resolve, 150);
        });
        return loader();
      })
      .then((mod) => ({ default: mod[exportName] })),
  );
}
